module.exports = __webpack_public_path__ + "media/images/landing/how_we_do_it_in_game-4087d4b67beac8c8d0e0c3239c06563b.png";